export default __webpack_public_path__ + "static/media/amor-propio-1-min.2bc37a74.jpg";